import React from 'react';
import './DashboardQuickServices.scss';
import ArrowLink from "../../common/ArrowLink/ArrowLink";
import {useTranslation} from "react-i18next";

const DashboardQuickServices = (props) => {

  const {t} = useTranslation();
  const {services} = props;

  return (
    <section className="cards-component" data-testid="DashboardQuickServices">
      <div className="cards-component-container">
        <div className="cards-component-top">
            <h2 className="headline-bold-fs2">{t("dashboard.header")}</h2>
          </div>
            <ul className="cards-container">
              {
                services.slice(0, 3).map((service, index) => (
                  <li key={index} className="cards-component-card" role="group" aria-roledescription="slide" aria-label={`Card ${index + 1} di ${services.slice(0, 3).length}`}>
                    <ArrowLink className="content-card"
                      aria-label={t("dashboard.serviceLink")}
                      to={service.linkTo}
                      onClick={() => service.linkTo !== "/selfread-add" && window.dataLayer.push({"event": service.linkTo === "/domiciliazione-bancaria" ? "domiciliazioneBancariaIniziata" : "attivazioneBolletta"})}
                    >
                      <div className="text-container">
                        <h4 className="headline-bold-fs4">{service.title}</h4>
                        <p className="paragraph-main-fs8">{service.description}</p>
                      </div>
                      <div className="bottom-card">
                        <div className="icon-wrapper" aria-hidden="true">
                          <div className={"icon icon-shadow " + service.icon}>
                          </div>
                          <div className={"icon icon-main " + service.icon}>
                          </div>
                        </div>
                      </div>
                    </ArrowLink>
                  </li>
                ))
              }
            </ul>
          </div>
    </section>
  )
};

DashboardQuickServices.propTypes = {};

export default DashboardQuickServices;
